import { render } from "./StaTistics.vue?vue&type=template&id=53b85dfa"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/StaTistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53b85dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53b85dfa', __exports__)) {
    api.reload('53b85dfa', __exports__)
  }
  
  module.hot.accept("./StaTistics.vue?vue&type=template&id=53b85dfa", () => {
    api.rerender('53b85dfa', render)
  })

}


export default __exports__